import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {AvlSpeedComponentDefinition} from './avl-speed.component.definition';
import {FormbirdInjectorService} from 'formbird-services';
import {SclUtilAvlService} from 'formbird-sc-shared';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as moment from 'moment';
import LayerVector from 'ol/layer/Vector';
import SourceVector from 'ol/source/Vector';
import Feature from 'ol/Feature';
import * as proj from 'ol/proj';
import * as olExtent from 'ol/extent';
import * as geom from 'ol/geom';
// import * as $ from 'jquery';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {ChangedDocumentService} from 'formbird-services';

// import { AvlTestData } from './avl-test-data'; // test test

@Component({
  templateUrl: './avl-speed.component.html',
  styleUrls: [
    './avl-speed.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlSpeedComponent extends AbstractComponent<AvlSpeedComponentDefinition> implements OnInit, AfterViewInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;
  @ViewChild('container', {static: false}) container: ElementRef;
  @ViewChild('content', {static: false}) content: ElementRef;
  @ViewChild('tooltipInfo', {static: false}) tooltipInfo: ElementRef;
  @ViewChild('info', {static: false}) divInfo: ElementRef;

  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  olMap;
  avlLocationField;
  minZoom;
  timeFormat = 'YYYY-MM-DDTHH:MM:SSZ';
  defaultZoom = 12;
  firstTime = true;
  displayArrorHeads = false;
  tooltipsTimeout = 3;
  format = 'dd/MM/yyyy';
  dateFormatGeneral = 'dd/MM/yyyy';
  vehicles;
  view;
  EPSG_3857 = 'EPSG:3857';
  EPSG_4326 = 'EPSG:4326';
  bottomLeft;
  topRight;
  maxPoints;
  isFirstTime = true;
  apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // combine
  autocompleteURL = 'https://www.geocode.farm/v3/json/forward/?addr='; // combine
  mapHeight;
  iMEIField;
  iMEIFilter;
  sourceVector;
  dataVector;
  sourceVectorMarker;
  dataVectorMarker;
  opened;
  opened1;
  isOpening;
  startDate;
  endDate;
  isIgnoreMapUpdate = false;
  minSpeed;
  maxSpeed;
  isfirstTimeupdateEnddate = false; // angularJS, init value = true
  isfirstTimeupdateStartdate = false; // angularJS, init value = true
  isfirstTimeupdateMaxSpeed = false; // angularJS, init value = true
  isfirstTimeupdateMinSpeed = false; // angularJS, init value = true
  chooseDate;
  isInit = true;
  infoPosition = {left: '0px', top: '0px'};
  tooltipPosition;
  mapCenter;
  toolTipTimeout = undefined;
  tooltipText;
  isPopoverOpen;
  previousSelectedFeature;
  focusPopup;
  currentPopover;
  pixelPopup;
  compId;
  mouseStopInterval;
  lastEvt = null;
  mouseX = 0;
  mouseY = 0;


  constructor(
    protected cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
  }

  ngOnInit() {

    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.defaultZoom === 'undefined' || this.componentDefinition.defaultZoom === null)) {
      this.defaultZoom = this.componentDefinition.defaultZoom;
    }
    const clientConfig = this.configService.clientConfig();
    if (clientConfig && clientConfig.dateFormat) {
      if (clientConfig.dateFormat.time) {
        this.timeFormat = clientConfig.dateFormat.time;
      }
      if (clientConfig.dateFormat.date) {
        this.dateFormatGeneral = clientConfig.dateFormat.date;
      }
    }
    if (!(typeof this.componentDefinition.displayArrorHeads === 'undefined' || this.componentDefinition.displayArrorHeads === null)) {
      this.displayArrorHeads = this.componentDefinition.displayArrorHeads;
    }
    if (!(typeof this.componentDefinition.iMEIField === 'undefined' || this.componentDefinition.iMEIField === null)) {
      this.iMEIField = this.componentDefinition.iMEIField;
    }
    if (!(typeof this.componentDefinition.iMEIFilter === 'undefined' || this.componentDefinition.iMEIFilter === null)) {
      this.iMEIFilter = this.componentDefinition.iMEIFilter;
    }
    if (!(typeof this.componentDefinition.maxPoints === 'undefined' || this.componentDefinition.maxPoints === null)) {
      this.maxPoints = this.componentDefinition.maxPoints;
    }

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 1);
    const strStart = 'dateTimeStart';
    this.document[strStart] = this.startDate;
    const strEnd = 'dateTimeEnd';
    this.document[strEnd] = new Date();

    if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
      this.mapHeight = '180';
    } else {
      let height = 180 * this.componentDefinition.heightNum;
      const docHeight = document.body.scrollHeight;
      if (height > (docHeight - 180)) {
        height = docHeight - 180;
      }
      this.mapHeight = '' + height;
    }

  }


  ngAfterViewInit() {
    // map
    this.loadMap();

    // watcher
    const dateTimeFieldStartSub = this.changedDocumentService.watch(this.componentDefinition.dateTimeFieldStart
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch dateTimeFieldStart, value = ' + fieldValue);
        this.document[this.componentDefinition.dateTimeFieldStart] = fieldValue;
        this.watchDateTimeFieldStart(fieldValue);
    });
    const dateTimeFieldEndSub = this.changedDocumentService.watch(this.componentDefinition.dateTimeFieldEnd
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch dateTimeFieldEnd, value = ' + fieldValue);
        this.document[this.componentDefinition.dateTimeFieldEnd] = fieldValue;
        this.watchDateTimeFieldEnd(fieldValue);
    });
    const maxSpeedSub = this.changedDocumentService.watch(this.componentDefinition.maxSpeed
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch maxSpeed, value = ' + fieldValue);
        this.document[this.componentDefinition.maxSpeed] = fieldValue;
        this.watchMaxSpeedDoc(fieldValue);
    });
    const minSpeedSub = this.changedDocumentService.watch(this.componentDefinition.minSpeed
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch minSpeed, value = ' + fieldValue);
        this.document[this.componentDefinition.minSpeed] = fieldValue;
        this.watchMinSpeedDoc(fieldValue);
    });
    this.subs.add(dateTimeFieldStartSub);
    this.subs.add(dateTimeFieldEndSub);
    this.subs.add(maxSpeedSub);
    this.subs.add(minSpeedSub);
  }

  loadMap() {
    console.log('loadMap');
    this.view = this.sclUtilMapService.setView(undefined, undefined, undefined, undefined, undefined, undefined);
    this.olMap = this.sclUtilMapService.initializeMapDefault([], this.target.nativeElement
      , this.view, [], false, null, null);
    this.sourceVector = new SourceVector({ wrapX: false});
    this.dataVector = new LayerVector({
      source: this.sourceVector,
      style: this.sclUtilMapService.styleFunction
    });
    this.olMap.addLayer(this.dataVector);

    this.sourceVectorMarker = new SourceVector({ wrapX: false});
    this.dataVectorMarker = new LayerVector({
      source: this.sourceVectorMarker,
      style: this.sclUtilMapService.styleFunction
    });

    this.olMap.addLayer(this.dataVectorMarker);

    this.olMap.on('pointermove', (evt) => {
      if (evt.dragging) {
        return;
      }

      this.lastEvt = evt;

      if (!this.mouseStopInterval && (!this.focusPopup || !this.currentPopover)) {
        this.mouseStopInterval = setInterval( () => {
            this.hasMouseStopped(evt);
          }, 450);
      }
    });
    this.olMap.on('click', (evt) => {
      if (this.isPopoverOpen) {
        this.dismissPopover();
      }
      const eventPixel = this.olMap.getEventPixel(evt.originalEvent);
      const feature = this.displayFeatureInfo(eventPixel); // this.displayFeatureInfo(evt.pixel);
      if (feature && feature.getProperties().url) {
        window.location.href = feature.getProperties().url;
      } else {
        this.previousSelectedFeature = undefined;
        this.focusPopup = false;
        this.currentPopover = undefined;
        this.cancelTooltipTimeout(feature);
        clearInterval(this.mouseStopInterval);
        this.mouseStopInterval = null;
      }
    });
    this.olMap.on('moveend', () => {
      if (this.isIgnoreMapUpdate) {
        this.isIgnoreMapUpdate = false;
      } else {
        this.changeData();
      }
    });


    if (!this.vehicles || this.vehicles.length <= 0) {
      const center = proj.fromLonLat([138.584043, -34.735613]);
      this.olMap.getView().setCenter(center);
      this.olMap.getView().setZoom(12);
      this.isIgnoreMapUpdate = true;
    }

    this.changeData();
  }

  open($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.opened = true;
    this.isOpening = true;
  }
  open1($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.opened1 = true;
    this.isOpening = true;
  }

  getDateInfo(date) {

    let startDate = new Date(this.startDate ? this.startDate : null);
    startDate = new Date(startDate.getTime());
    console.log('Offset Time: ' + startDate.getTimezoneOffset()
     + '\tstartDate.getTime(): ' + startDate.getTime() + '\tTestDate: ' + startDate);

    let endDate = new Date();
    endDate = new Date(endDate.getTime());

    const startDateFormat = startDate.toISOString();
    const endDateFormat = endDate.toISOString();

    const args = [];
    args.push(startDateFormat);
    args.push(endDateFormat);

    return args;
  }

  changeData() {
    if (this.olMap == null) {
      return;
    }
    this.vehicles = this.document[this.componentDefinition.avlVehiclesField];
    if (!this.vehicles || this.vehicles.length <= 0) {
        if (this.olMap.getView().getZoom() < this.minZoom) {
          this.notificationService.printMessage('Please zoom map closer');
        } else {
          const dates = this.getDateInfo(new Date(this.endDate));
          console.log('apiGetAllAvlEvent: calculated start date: ' + dates[0] + '\tcalculated end date: ' + dates[1]);
          const extent = this.olMap.getView().calculateExtent(this.olMap.getSize());
          const bottomLeft = proj.transform(olExtent.getBottomLeft(extent), this.EPSG_3857, this.EPSG_4326);
          const topRight = proj.transform(olExtent.getTopRight(extent), this.EPSG_3857, this.EPSG_4326);

          const params = {
            functionName: 'getAvlAllEventInRange',
            componentDocumentName: 'sc-avl-speed',
            functionParameters: [this.componentDefinition.dataService, dates[0], dates[1],
             this.minSpeed, this.maxSpeed, bottomLeft, topRight]
          };

          // apiGetAvlAllEventInRange
          this.httpClient.post('api/execute', params).subscribe( (customData: any) => {
            this.proccessData(customData.data);
          }, (err) => {
            console.error('error query current location :');
            console.error(err);
          });
        }
    } else {
        this.chooseDate = true;
        this.fieldValue = this.document[this.fieldName];

        if (this.isFirstTime) {
            console.log('get last event');
            const params = {
              functionName: 'getAvlEvent',
              componentDocumentName: 'sc-avl-speed',
              functionParameters: [this.componentDefinition.dataService, this.vehicles[0].documentId]
            };
            // apiGetAvlEvent
            this.httpClient.post('api/execute', params).subscribe( (customData: any) => {
              // customData = AvlTestData.getAvlEvent; // test test
              this.proccessData(customData.data);
            }, (err) => {
              console.error('error query current location :');
              console.error(err);
            });
        } else {
            console.log('request all event');
            const dates = this.getDateInfo(new Date(this.endDate));
            console.log('apiGetAvlEvent: calculated start date: ' + dates[0] + '\tcalculated end date: ' + dates[1]);

            const extent = this.olMap.getView().calculateExtent(this.olMap.getSize());
            const bottomLeft = proj.transform(olExtent.getBottomLeft(extent), this.EPSG_3857, this.EPSG_4326);
            const topRight = proj.transform(olExtent.getTopRight(extent), this.EPSG_3857, this.EPSG_4326);

            const params = {
              functionName: 'getAvlEventInRange',
              componentDocumentName: 'sc-avl-speed',
              functionParameters: [this.componentDefinition.dataService, this.vehicles[0].documentId
              , dates[0], dates[1], this.minSpeed, this.maxSpeed, bottomLeft, topRight]
            };

            // apiGetAvlEventInRange
            this.httpClient.post('api/execute', params).subscribe( (customData: any) => {
              // // test test begin
              // const json = JSON.stringify(AvlTestData.getAvlAllEventInRange2);
              // const testData = JSON.parse(json);
              // if ( this.document[this.componentDefinition.minSpeed] > 0 && this.document[this.componentDefinition.maxSpeed] > 0 ) {
              //   const minSpeed = this.document[this.componentDefinition.minSpeed];
              //   const maxSpeed = this.document[this.componentDefinition.maxSpeed];
              //   const lst = [];
              //   for (let i = 0; i < testData.data.length; i++) {
              //     if (testData.data[i].speedKPH >= minSpeed && testData.data[i].speedKPH <= maxSpeed) {
              //       lst.push(testData.data[i]);
              //     }
              //   }
              //   testData.data = lst;
              // }
              // customData =  testData;
              // // test test end
              this.proccessData(customData.data);
            });
        }
    }
  }
  proccessData(data) {
    const customData = data;
    const vehicles = [];
    if (customData && customData.length > 0) {
        console.log('customData[0]: ');
        console.log(customData[0]);
        if (this.maxPoints) {
            if (customData.length > this.maxPoints) {
                console.log('Too much data: ' + customData.length);
                this.notificationService.printMessage('Too much data selected: ' + customData.length + ', please zoom in closer');
                // scope.grid.options.data = [];
                // table.clear();
                return;
            }
        }
        this.clearMap();

        const debugPoint = [];
        for (let i = 0; i < customData.length; i++) {
            const locationGeo = customData[i].locationGeo;
            const valJson = customData[i];
            const feature = locationGeo.features[0];

            const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');

            debugPoint.push(feature.geometry.coordinates);


            if (vehicleRel && vehicleRel.documentId) {
                const temp = vehicles.find(x => x.documentId === vehicleRel.documentId);
                if (!temp) {
                  vehicles.push({documentId: vehicleRel.documentId});
                }
            }
        }

        console.log('Size of imeis is ' + vehicles.length);
        // console.log("points: " + JSON.stringify(debugPoint));


        for (let i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i];
            const data1 = [];
            for (let j = 0; j < customData.length; j++) {
              const locationGeo = customData[j].locationGeo;
              const valJson = customData[j];

              const feature = locationGeo.features[0];
              const properties = feature.properties;

              const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');

              if (vehicleRel && vehicleRel.documentId && vehicleRel.documentId === vehicle.documentId) {
                data1.push(valJson);
              }
            }

            if (data1.length > 1) {
                vehicle.startDate = data1[0].eventDate;
                vehicle.endDate = data1[data1.length - 1].eventDate;
            }

            this.loadDataForDevice(vehicle, data1);
        }
    } else {
      this.notificationService.printMessage('No data');
      this.clearMap();
    }
  }
  loadDataForDevice(documentId, data) {
    console.log(' loadDataForDevice ');
    const results = [];

    if (this.isFirstTime && this.vehicles && this.vehicles.length > 0 ) {
      // first time load map, just center map to last event
      console.log('data.length=' + data.length);
      if ( data.length > 0) {
        this.isFirstTime = false;
        console.log('center map, request location events');
        const res: any = this.sclUtilMapService.parseAVLData_New(data[0]);
        const center = proj.fromLonLat([res.longitude, res.latitude]);
        // center map, auto trigger changeData
        this.olMap.getView().setCenter(center);
        this.olMap.getView().setZoom(16);
        // request events around
        // changeData();
      }
    } else {
      for (let j = 0; j < data.length; j++) {
        const locationGeo = data[j].locationGeo;
        const valJson = data[j];
        const feature = locationGeo.features[0];
        const properties = feature.properties;

        const icon = this.sclUtilMapService.checkAVLSpeed(SclMapConstantService.AVL_SPEED_BEGINNING,
            parseFloat(valJson.speedKPH).toFixed(5),
            parseFloat(valJson.heading), 5, 20, 50, 100, 150);
        const res = this.sclUtilMapService.parseAVLData_New(valJson);
        res.imeiDocumentsRel = data[j].imeiDocumentsRel;
        res.icon = icon;
        results.push(res);
      }

      this.showMap(results);
    }
  }
  showMap(data) {
    console.log('show ' + data.length + ' events');


    if (data.length === 0) {
      this.notificationService.printMessage('No event found');
      return;
    }

    if (this.maxPoints) {
      if (data.length > this.maxPoints) {
        console.log('Too much data: ' + data.length);
        this.notificationService.printMessage('Too much data selected: ' + data.length + ', please zoom in closer');
        return;
      }
    }

    let currentLat = 0;
    let currentLon = 0;
    let nextLat = 0;
    let nextLon = 0;

    for (let i = 0; i < data.length - 1; i++) {
        currentLat = parseFloat(data[i].latitude);
        currentLon = parseFloat(data[i].longitude);
        // the line is stored in the index one above the point, so read the line in the next item after the point
        const lineIndex = i + 1;
        // read the values using the lineIndex
        nextLat = parseFloat(data[lineIndex].latitude);
        nextLon = parseFloat(data[lineIndex].longitude);

        const idIdx = data[i].id;


        // parse coordinate using the index
        // var coor = scope.sclUtilMap.parseStandardCoor(currentLat, currentLon);
        // var coor  = ol.proj.transform([currentLat, currentLon], EPSG_4326, EPSG_3857);
        const coor = proj.transform([currentLon, currentLat], this.EPSG_4326, this.EPSG_3857);

        // parse coordinate using the lineIndex
        // var coorNext = scope.sclUtilMap.parseStandardCoor(nextLat, nextLon);
        // var coorNext  = ol.proj.transform([nextLat, nextLon], EPSG_4326, EPSG_3857);
        const coorNext = proj.transform([nextLon, nextLat], this.EPSG_4326, this.EPSG_3857);

        // add point at i index
        const pointFeature1 = this.parsePoint(data[i]);
        // parse line from index, index + 1

        const fea1 = this.sourceVector.getFeatureById(idIdx);
        if (!fea1) {
          this.sourceVector.addFeature(pointFeature1);
        }

        const lineId = idIdx + ' - line';
        const lineFeature = this.parseLineString(coor[0], coor[1], coorNext[0], coorNext[1], lineId);
        const feaLine = this.sourceVector.getFeatureById(lineId);
        if (!feaLine) {
          this.sourceVector.addFeature(lineFeature);
        }
    }

    // add last point point.latitude, point.longitude
    const lastItem = data[data.length - 1];
    const pointFeature = this.parsePoint(lastItem);
    const fea = this.sourceVector.getFeatureById(lastItem.id);
    if (!fea) {
      this.sourceVector.addFeature(pointFeature);
    }


  }

  clearMap() {
    if (this.sourceVector) {
      this.sourceVector.clear();
    }
  }
  formatTime(time) {
    const  longDate = 'MMM DD YYYY, h:mm:ss a';
    const timeReturn = moment(time).fromNow() + ' (' + moment(time).format(longDate) + ')';
    return timeReturn;
  }
  parsePoint(point) {
    // var coor = scope.sclUtilMap.parseStandardCoor(point.latitude, point.longitude);
    // var coor  = ol.proj.transform([point.latitude, point.longitude], EPSG_4326, EPSG_3857);
    const coor = proj.transform([point.longitude, point.latitude], this.EPSG_4326, this.EPSG_3857);

    let url = '';
    let deviceName = '';
    let vehicleData: any = this.sclUtilAvlService.getRelatedDocument(point, 'vehicle');
    if (vehicleData) {
      url = 'form/' + vehicleData.documentId;
      deviceName = vehicleData.name;
    }

    vehicleData = '<div><a href="' + url + '"><b>Vehicle: ' + deviceName + '</b></a></div>';

    const imeiContent = '<div><bold>IMEI : </bold> ' + point.imei + '</div>';
    // var address = "";
    // if (typeof point.address !== 'undefined') {
    //    address = "<div><bold>Address : </bold> " + point.address + "</div>";
    // }

    const gps = '<div><bold>GPS : </bold> ' + point.longitude.toFixed(4) + '/' +
        point.latitude.toFixed(4) + '</div>';

    const eventDate = new Date(point.eventDate);

    // var dateFormat = scope.sclUtilDate.parseDate(eventDate, timeFormat);
    const dateContent = '<div><bold>Time : </bold> ' + this.formatTime(eventDate) + '</div>';

    const speedContent = '<div><bold>Speed : </bold> ' + point.speedKPH + '</div>';
    const tooltip = /*imeiContent + address +*/vehicleData + gps + dateContent + speedContent;

    const propertiesData = {
        address: tooltip,
        icon: point.icon,
        imei: point.imei
    };

    const pointFeature = new Feature({geometry: new geom.Point(coor)});
    pointFeature.setProperties(propertiesData);
    pointFeature.setId(point.id);

    return pointFeature;
  }
  parseLineString(coor, coor1, nextCoor, nextCoor1, id) {
    const lineFeature = this.sclUtilMapService.parseLineString(coor, coor1, nextCoor, nextCoor1);
    lineFeature.setId(id);
    return lineFeature;
  }
  setTooltipPosition(pixel) {
    const featureLeftPos = pixel[0];
    const featureTopPos = pixel[1];

    this.infoPosition.left = featureLeftPos + 'px';
    this.infoPosition.top = featureTopPos + 'px';
    this.isPopoverOpen = true;

    // set the tooltip position
    let tooltipHorizontalPosition;
    let tooltipVerticalPosition;

    if (!this.mapCenter || !this.mapCenter.x || !this.mapCenter.y) {
      this.getMapSize();
    }

    if (featureLeftPos < this.mapCenter.x) {
        tooltipHorizontalPosition = 'left';
    } else {
        tooltipHorizontalPosition = 'right';
    }

    if (featureTopPos < this.mapCenter.y) {
        tooltipVerticalPosition = 'bottom';
    } else {
        tooltipVerticalPosition = 'top';
    }

    // this.tooltipPosition = tooltipVerticalPosition + '-' + tooltipHorizontalPosition;
    const divInfoPos = this.divInfo.nativeElement.getBoundingClientRect();
    let tipWidth = divInfoPos.width; let tipHeight = divInfoPos.height;
    if (tipWidth === 0) { tipWidth = 276; }
    if (tipHeight === 0) { tipHeight = 68; }
    let tipPos = { left: 0, top: 0 };
    if (tooltipVerticalPosition === 'top') {
      if (tooltipHorizontalPosition === 'left') {
        tipPos = {
          left: featureLeftPos + 1,
          top: featureTopPos - tipHeight + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos - tipWidth + 1,
          top: featureTopPos - tipHeight + 1
        };
      }
    } else {// bottom
      if (tooltipHorizontalPosition === 'left') {
        tipPos = {
          left: featureLeftPos + 1,
          top: featureTopPos + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos - tipWidth + 1,
          top: featureTopPos + 1
        };
      }
    }
    this.infoPosition.left = tipPos.left + 'px';
    this.infoPosition.top = tipPos.top + 'px';
    this.detectChanges();
  }
  getMapSize() {
    const mapSize = this.olMap.getSize();

    if (mapSize) {
      const mapWidth = mapSize[0];
      const mapHeight = mapSize[1];
      this.mapCenter = {x: mapWidth / 2, y: mapHeight / 2};
    } else {
      console.log('Couldn\'t get size of map to enable tooltips');
    }
  }
  cancelTooltipTimeout(feature) {
    if (this.toolTipTimeout && this.tooltipsTimeout !== undefined) {
      clearInterval(this.toolTipTimeout);
      this.toolTipTimeout = undefined;
    }
  }
  scheduleTooltip(feature) {
    if (feature && this.tooltipsTimeout !== undefined) {
      this.toolTipTimeout = setInterval( () => {
        this.dismissPopover();
      }, this.tooltipsTimeout * 1000);
    }
  }
  dismissPopover() {
    clearInterval(this.toolTipTimeout);
    this.toolTipTimeout = null;
    this.previousSelectedFeature = undefined;
    this.isPopoverOpen = false;
    this.focusPopup = false;
    this.currentPopover = undefined;
    this.tooltipInfo.nativeElement.innerHTML = '';
    this.tooltipText = '';
    this.infoPosition = {left: '0px', top: '0px'};

    this.detectChanges();
  }
  selectAssetPopup() {
    // Note : this function was called by getHTMLTooltip function
  }
  getHTMLTooltip(features) {
    // Note : this function is commented inside displayFeatureInfo
  }
  displayFeatureInfo(pixel) {
    const feature = this.olMap.forEachFeatureAtPixel(pixel, (fea, layer) => {
        if (layer) {
          return fea;
        }
      }, {hitTolerance: 10}
    );
    if (feature && feature.getProperties().address) {
      let shouldShow = false;
      // if (features.length > 0) {
      this.pixelPopup = pixel;
      // var tooltip = getHTMLTooltip(features, pixel);
      const isPopupShowed = false;
      if ((this.previousSelectedFeature === undefined || this.previousSelectedFeature !== feature)
       && (!this.focusPopup || !isPopupShowed)) {
          this.cancelTooltipTimeout(feature);


          const htmlText = feature.getProperties().address;
          this.tooltipText = htmlText;
          this.tooltipInfo.nativeElement.innerHTML = htmlText;

          this.previousSelectedFeature = feature;
          shouldShow = true;
          this.detectChanges();
          this.setTooltipPosition(this.pixelPopup);
          this.scheduleTooltip(feature);
      }

      if (!isPopupShowed && shouldShow) {
        $(this.divInfo).trigger('hover');

        this.isPopoverOpen = true;
        const popover = $(this.divInfo.nativeElement)[0].querySelectorAll('div.popover-inner')[0];

        this.currentPopover = popover;
        this.focusPopup = false;
        if (popover) {
          popover.onmouseover = () => {
            this.focusPopup = true;
            this.cancelTooltipTimeout(feature);
          };
          popover.onmouseout = () => {
            this.focusPopup = false;
            this.scheduleTooltip(feature);
          };
        }
      }
    }
    return feature;
  }
  hasMouseStopped(evt) {
    const newMouseX = evt.originalEvent.x;
    const newMouseY = evt.originalEvent.y;

    if ((newMouseX === this.mouseX) && (newMouseY === this.mouseY)) {
      // stopped moving
      clearInterval(this.mouseStopInterval);
      this.mouseStopInterval = null;

      this.displayFeatureInfo(this.olMap.getEventPixel(this.lastEvt.originalEvent));
    }
    this.mouseX = newMouseX;
    this.mouseY = newMouseY;
  }

  watchEndDate() {
    if (this.isfirstTimeupdateEnddate) {
      this.isfirstTimeupdateEnddate = false;
    } else {
      this.changeData();
    }
  }
  watchStartDate() {
    if (this.isfirstTimeupdateStartdate) {
      this.isfirstTimeupdateStartdate = false;
    } else {
      this.changeData();
    }
  }
  watchMaxSpeed() {
    if (this.isfirstTimeupdateMaxSpeed) {
      this.isfirstTimeupdateMaxSpeed = false;
    } else {
      this.changeData();
    }
  }
  watchMinSpeed() {
    if (this.isfirstTimeupdateMinSpeed) {
      this.isfirstTimeupdateMinSpeed = false;
    } else {
      this.changeData();
    }
  }
  watchDateTimeFieldStart(value) {
    console.log('Change start date = ' + value);
    if (!value) { value = new Date(); }
    this.startDate = value;
    this.watchStartDate();
  }

  watchDateTimeFieldEnd(value) {
    console.log('Change end date = ' + value);
    if (!value) { value = new Date(); }
    this.endDate = value;
    this.watchEndDate();
  }

  watchMaxSpeedDoc(value) {
    console.log('Change maxSpeed = ' + value);
    if (!value) { value = Number.MAX_VALUE; }
    this.maxSpeed = value;
    this.watchMaxSpeed();
  }

  watchMinSpeedDoc(value) {
    console.log('Change minSpeed = ' + value);
    if (!value) { value = 0; }
    this.minSpeed = value;
    this.watchMinSpeed();
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
